import React from 'react'
import { Modal } from '@workwhile/ui'
import { LocationEditModalProvider } from './context/LocationEditModalProvider'
import { CompanyLocation } from 'api/company/location'
import { LocationEditModalMain } from './components/LocationEditModalMain'

export const LocationEditModal = ({
  location,
  onClose,
}: {
  location: CompanyLocation
  onClose: () => void
}) => {
  return (
    <Modal open={true} onClose={onClose}>
      <Modal.Consumer>
        {({ closeModal }) => (
          <LocationEditModalProvider
            location={location}
            closeModal={closeModal}
          >
            <LocationEditModalMain />
          </LocationEditModalProvider>
        )}
      </Modal.Consumer>
    </Modal>
  )
}
